import React, { Component } from 'react';
import Styled from 'styled-components';
import * as color from '../colors';

import bg from '../../assets/images/sidebar/cat-4.png';

import Button from './../common/button';
import SectionAside from './../common/sectionAside';
import InputField from './../common/inputField';

const Section = Styled.section`
display: grid;
grid-template-columns: 25fr 60fr;
background-color: ${color.tertiary};
height: 100vh;
@media only screen and (max-width: 700px){
grid-template-columns: 1fr;
};
`;

const SectionWrapper = Styled.section`
height: 100vh;
display:grid;
grid-template-rows:  1fr max-content;
place-items:center;
`;

const SectionBody = Styled.section``;

const SectionHeader = Styled.header`
margin: 2rem 0;
`;

const SectionHeading = Styled.h2`
max-width: 30ch;
line-height: 1;
color:${color.primary};
`;

const SectionFooter = Styled.footer`
width: 100%;
background-color:${color.white};
padding: 1rem;
text-align:center;
&>*{margin:0  0.5rem;}
`;

const Pair = Styled.div`
display: flex;
margin: 1rem 0rem;
&>*:not(:first-child){margin-left:0.5rem;};
@media only screen and (max-width: 700px){
  flex-direction: column;
}
`;

class ScheduleThree extends Component {
  state = {};

  render() {
    const { onNext, onPrev } = this.props;

    return (
      <Section>
        <SectionAside
          items={[
            'A photo update for you along with chat about the service',
            'Notifications of sitter arrival and departure times',
            'Treats for your pet, with your permission of course',
          ]}
          image={bg}
        />
        <SectionWrapper>
          <SectionBody>
            <SectionHeader>
              <SectionHeading>
                Finally, how would you like to pay for your dog walk?
              </SectionHeading>
            </SectionHeader>

            <form>
              <InputField
                id={'cardName'}
                label={'Card Name'}
                placeHolder={'eg. John Smith'}
                type={'text'}
              />
              <InputField
                id={'cardNumber'}
                label={'Card Number'}
                placeHolder={'eg. 123 456 789'}
                type={'text'}
              />
              <Pair>
                <InputField
                  id={'expirationDate'}
                  label={'Expiration Date'}
                  placeHolder={'Eg. 01/21'}
                  type={'text'}
                />
                <InputField
                  id={'ccv'}
                  label={'CCV'}
                  placeHolder={'Eg. 1234'}
                  type={'number'}
                />
              </Pair>
            </form>
          </SectionBody>

          <SectionFooter>
            <Button onClick={onPrev} type={'light'} text={'Back'} rounded />
            <Button onClick={onNext} type={'primary'} text={'Next'} rounded />
          </SectionFooter>
        </SectionWrapper>
      </Section>
    );
  }
}

export default ScheduleThree;
